$ ->
  # Features text slider
  $('.feature-slider').slick
    infinite: true,
    autoplay: true,
    speed: 800,
    autoplaySpeed: 3000,
    cssEase: 'linear'
  $('.slick-slide').on 'click', -> $(@).toggleClass 'selected'

  # Features list actions
  $('.svg-wrapper img').hide()
  $('.login-dentist, .login-patient').show()
  $('#login-dentist, #login-patient').addClass 'selected'
  $('.features-list button').on 'click', ->
    if $(@).parent().parent().hasClass('left')
      $('.features-list .left button').removeClass 'selected'
    else
      $('.features-list .right button').removeClass 'selected'
    $(@).toggleClass 'selected'
    img = $('.' + $(@).attr 'id')
    if img.is ':hidden'
#      position = $(@).parent().parent().hasClass('left') ? 'left' : 'right'
#      $(".svg-wrapper.#{position} img").fadeOut()
      if $(@).parent().parent().hasClass('left')
        $(".svg-wrapper.left img").fadeOut()
      else
        $(".svg-wrapper.right img").fadeOut()
      img.fadeIn()
    else
      img.fadeOut() unless $('.svg-wrapper img:visible').length <= 2
